export default function Terms() {
  return (
    <div className="container mx-auto px-6 py-20 max-w-3xl">
      <h1 className="text-5xl md:text-6xl font-serif font-bold tracking-tighter mb-12">Terms of Use</h1>
      <div className="prose prose-invert prose-lg max-w-none">
        <p>By using Noted you agree to the Community Rules and the Rights &amp; Licensing terms. Do not upload material you do not have the right to share. Do not use Noted to publish AI-generated audio.</p>
        <p>We may remove commits, close rounds, or suspend accounts that violate the rules. The service is provided as-is while we are in early access; we will do our best to preserve your work but cannot guarantee uninterrupted service.</p>
        <p>Disputes are handled first by contacting an admin. Any formal disputes are governed by the laws of your jurisdiction of residence.</p>
      </div>
    </div>
  );
}
